import { render, staticRenderFns } from "./CategoryBox.vue?vue&type=template&id=302f24bd&scoped=true"
import script from "./CategoryBox.vue?vue&type=script&lang=js"
export * from "./CategoryBox.vue?vue&type=script&lang=js"
import style0 from "./CategoryBox.vue?vue&type=style&index=0&id=302f24bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302f24bd",
  null
  
)

export default component.exports